import {createCartoCiudadFindConfig, createCartoCiudadSearchConfig} from "../model";
import {CartoCiudadService} from "../service";

class CartoCiudadSearchAdapter {
    constructor() {}

    getList(filter) {
        console.log({filter});
        const cartociudadConfig = createCartoCiudadSearchConfig({
            q: filter.search,
            provincia_filter: "Almería",
        });
        return CartoCiudadService.get("candidates?", cartociudadConfig.getURL()).then(
            results => {
                return results.map(result => {
                    return {id: result.id, value: result.address, type: result.type};
                });
            }
        );
    }

    find(id, type) {
        const cartociudadConfig = createCartoCiudadFindConfig({
            id,
            type,
        });
        return CartoCiudadService.get("find?", cartociudadConfig.getURL());
    }
}

const createCartoCiudadSearchAdapter = () => {
    return new CartoCiudadSearchAdapter();
};

export default createCartoCiudadSearchAdapter;
